<div class="summary-card">
  <h3 class="spreadsheet-name">
    <capra-icon class="gsheets-icon"
      icon="illo-gsheets-file"
    ></capra-icon>
    {{ spreadsheetName }}
  </h3>
  <h4 class="worksheet-name">
    Worksheet tab: {{ worksheetName }}
  </h4>
  <ul class="metadata-list">
    <li class="metadata-row">
      <strong class="metadata-label">
        Spreadsheet URL
      </strong>
      <a class="metadata-content link"
        [href]="spreadsheetUrl"
        target="_blank"
        rel="noopener noreferrer"
        capraTooltip
        [tooltipContent]="tooltipUrl"
        [tooltipContentIsHtml]="true"
        tooltipPlacement="top"
        [tooltipDelay]="500"
      >
        {{ spreadsheetUrl }}
        <capra-icon class="external-url-icon"
          icon="icon-new-tab"
        ></capra-icon>
      </a>
    </li>
    <li class="metadata-row">
      <strong class="metadata-label">
        Sheet range
      </strong>
      <div class="metadata-content">
        {{ worksheetRange }}
      </div>
    </li>
    <li class="metadata-row">
      <strong class="metadata-label">
        Spreadsheet owned by
      </strong>
      <div class="metadata-content">
        {{ ownedBy ?? '--' }}
      </div>
    </li>
    <li class="metadata-row">
      <strong class="metadata-label">
        Connected by
      </strong>
      <div class="metadata-content">
        {{ connectedBy }}
      </div>
    </li>
    <li class="metadata-row">
      <strong class="metadata-label">
        Last synced
      </strong>
      <div class="metadata-content">
        {{ lastSynced }}
      </div>
    </li>
    <li class="metadata-row">
      <strong class="metadata-label">
        Last synced by
      </strong>
      <div class="metadata-content">
        {{ lastSyncedBy }}
      </div>
    </li>
  </ul>
</div>

<footer mode-tab-footer>
  <div>
    <label>Source</label>
    Google Sheet Integration
  </div>
</footer>
